export default __webpack_public_path__ + "media/images/theme_apple/listGroup-a77a51519a15ddb07b693bee9dc3ecca.png";